import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "spb_light"
}
const _hoisted_2 = { class: "left" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("label", { for: "name" }, "Наличие и вид подсветки", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", null, "Нажмите, чтобы выбрать из списка", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("label", { for: "title" }, "Габаритные размеры, м", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", null, "Ширина", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", null, "Высота", -1)
const _hoisted_8 = { class: "quantitySelect" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", null, "Количество инф. полей", -1)
const _hoisted_10 = { for: "title" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", null, "Ширина", -1)
const _hoisted_12 = ["value", "onInput", "onChange"]
const _hoisted_13 = /*#__PURE__*/_createElementVNode("span", null, "Высота", -1)
const _hoisted_14 = ["value", "onInput", "onChange"]
const _hoisted_15 = { class: "right" }
const _hoisted_16 = { for: "title" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("span", null, "Ширина", -1)
const _hoisted_18 = ["value", "onInput", "onChange"]
const _hoisted_19 = /*#__PURE__*/_createElementVNode("span", null, "Высота", -1)
const _hoisted_20 = ["value", "onInput", "onChange"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Dropdown = _resolveComponent("Dropdown")!

  return (_ctx.subpage == 1)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", null, [
            _hoisted_3,
            _hoisted_4,
            _createVNode(_component_Dropdown, {
              modelValue: _ctx.number_type_illumination_title,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.number_type_illumination_title) = $event)),
              editable: "",
              options: _ctx.number_type_illumination_options,
              optionLabel: "name",
              placeholder: _ctx.number_type_illumination_default.name,
              style: {"width":"497px"},
              onChange: _ctx.number_type_illumination_change
            }, null, 8, ["modelValue", "options", "placeholder", "onChange"]),
            (_ctx.document.number_type_illumination != 'Светодиодные модули, комплектующие и трансформаторы' && _ctx.document.number_type_illumination != '-')
              ? _withDirectives((_openBlock(), _createElementBlock("input", {
                  key: 0,
                  class: "input",
                  type: "text",
                  placeholder: "Введите наличие и вид подсветки",
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.document.number_type_illumination) = $event)),
                  style: {"width":"497px"}
                }, null, 512)), [
                  [_vModelText, _ctx.document.number_type_illumination]
                ])
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", null, [
            _hoisted_5,
            _createElementVNode("section", null, [
              _createElementVNode("div", null, [
                _hoisted_6,
                _withDirectives(_createElementVNode("input", {
                  class: "input",
                  placeholder: "3,32",
                  type: "text",
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.document.construction_width) = $event))
                }, null, 512), [
                  [_vModelText, _ctx.document.construction_width]
                ])
              ]),
              _createElementVNode("div", null, [
                _hoisted_7,
                _withDirectives(_createElementVNode("input", {
                  class: "input",
                  placeholder: "0,8",
                  type: "text",
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.document.construction_height) = $event))
                }, null, 512), [
                  [_vModelText, _ctx.document.construction_height]
                ])
              ]),
              _createElementVNode("div", _hoisted_8, [
                _hoisted_9,
                _createVNode(_component_Dropdown, {
                  modelValue: _ctx.info_count_title,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.info_count_title) = $event)),
                  editable: "",
                  options: _ctx.info_count_options,
                  optionLabel: "name",
                  placeholder: _ctx.info_count_default.name,
                  style: {"width":"155px"},
                  onChange: _ctx.info_count_change
                }, null, 8, ["modelValue", "options", "placeholder", "onChange"])
              ])
            ])
          ]),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.construction_info_custom1, (input, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "info",
              key: index
            }, [
              _createElementVNode("label", _hoisted_10, "Информационное поле №" + _toDisplayString(index+1), 1),
              _createElementVNode("section", null, [
                _createElementVNode("div", null, [
                  _hoisted_11,
                  _createElementVNode("input", {
                    class: "input",
                    placeholder: "0,2",
                    type: "number",
                    value: input[0],
                    onInput: ($event: any) => (_ctx.info_set_width(index, $event)),
                    onChange: ($event: any) => (_ctx.info_set_width(index, $event))
                  }, null, 40, _hoisted_12)
                ]),
                _createElementVNode("div", null, [
                  _hoisted_13,
                  _createElementVNode("input", {
                    class: "input",
                    placeholder: "0,2",
                    type: "number",
                    value: input[1],
                    onInput: ($event: any) => (_ctx.info_set_height(index, $event)),
                    onChange: ($event: any) => (_ctx.info_set_height(index, $event))
                  }, null, 40, _hoisted_14)
                ])
              ])
            ]))
          }), 128))
        ]),
        _createElementVNode("div", _hoisted_15, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.construction_info_custom2, (input, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "info",
              key: index
            }, [
              _createElementVNode("label", _hoisted_16, "Информационное поле №" + _toDisplayString(index+5), 1),
              _createElementVNode("section", null, [
                _createElementVNode("div", null, [
                  _hoisted_17,
                  _createElementVNode("input", {
                    class: "input",
                    placeholder: "0,2",
                    type: "number",
                    value: input[0],
                    onInput: ($event: any) => (_ctx.info_set_width(index+5, $event)),
                    onChange: ($event: any) => (_ctx.info_set_width(index+5, $event))
                  }, null, 40, _hoisted_18)
                ]),
                _createElementVNode("div", null, [
                  _hoisted_19,
                  _createElementVNode("input", {
                    class: "input",
                    placeholder: "0,2",
                    type: "number",
                    value: input[1],
                    onInput: ($event: any) => (_ctx.info_set_height(index+5, $event)),
                    onChange: ($event: any) => (_ctx.info_set_height(index+5, $event))
                  }, null, 40, _hoisted_20)
                ])
              ])
            ]))
          }), 128))
        ])
      ]))
    : _createCommentVNode("", true)
}